module.exports = __webpack_public_path__ + "img/81.8ee28692.jpg";